import AxiosInstance from '../../AxiosInstance';

const baseUrlApi = '/master/billing';
const baseUrlApimaster = '/master';

const BillingService = {

    getChargeType:()=>{
        return AxiosInstance.get(baseUrlApi + '/getChargeType');
    },
    insertChargeType:(details)=> {
        return AxiosInstance.post(baseUrlApi + '/insertChargeType', details);
    },
    updateChargeType:(details)=> {
        return AxiosInstance.put(baseUrlApi + '/updateChargeType', details);
    },
    deleteChargeType:(chargeTypeName)=> {
        return AxiosInstance.delete(baseUrlApi + '/deleteChargeType?chargeTypeName=' + chargeTypeName);
    },

    //bill
    getCharge:()=> {
        return AxiosInstance.get(baseUrlApi + '/getCharge');
    },
    insertCharge:(details)=> {
        return AxiosInstance.post(baseUrlApi + '/insertCharge', details);
    },
    updateCharge:(details)=> {
        return AxiosInstance.put(baseUrlApi + '/updateCharge', details);
    },
    deleteCharge:(chargeName)=> {
        return AxiosInstance.delete(baseUrlApi + '/deleteCharge?chargeName=' + chargeName);
    },

    //Quatetion
    getQuotationType:()=> {
        return AxiosInstance.get(baseUrlApimaster + '/getQuotationType');
    },
    getItem:()=> {
        return AxiosInstance.get(baseUrlApi + '/getItem');
    },
    getCustomerType:(flag)=> {
        return AxiosInstance.get(baseUrlApi + '/getCustomerType?flag=' + flag);
    },
    getCustomerBasedCustomerType:(customerType)=> {
        return AxiosInstance.get(baseUrlApimaster + '/getCustomerBasedCustomerType?customerType=' + customerType);
    },
    getCustomLocation:()=> {
        return AxiosInstance.get(baseUrlApi + '/getCustomLocation');
    },
    getUOM:()=> {
        return AxiosInstance.get(baseUrlApi + '/getUOM');
    },
    getImporter:(details)=> {
        return AxiosInstance.post(baseUrlApi + '/getImporter', details);
    },
    getForwarder:(details)=> {
        return AxiosInstance.post(baseUrlApi + '/getForwarder', details);
    },
    getCustomHouseCode:(details)=> {
        return AxiosInstance.post(baseUrlApi + '/getCustomHouseCode', details);
    },
    getUOMSearch:(details)=> {
        return AxiosInstance.post(baseUrlApi + '/getUOMSearch', details);
    },
    getCustomTariff:(details)=> {
        return AxiosInstance.post(baseUrlApi + '/getCustomTariff', details);
    },
    getCustomTariffALL:()=> {
        let details = { importerIecNo: '-1', clearanceLocationCode: '-1', unitCode: '-1' }
        return AxiosInstance.post(baseUrlApi + '/getCustomTariff', details);
    },
    getCustomTariffFreightForwarder:(details) =>{
        return AxiosInstance.post(baseUrlApi + '/getCustomTariffFreightForwarder', details);
    },
    getCustomTariffFreightForwarderAll:()=> {
        let details = { importerIecNo: '-1', clearanceLocationCode: '-1', unitCode: '-1' }
        return AxiosInstance.post(baseUrlApi + '/getCustomTariffFreightForwarder', details);
    },
    insertCustomTariff:(details)=> {
        return AxiosInstance.post(baseUrlApi + '/insertCustomTariff', details)
    },
    updateCustomTariff:(details)=> {
        return AxiosInstance.put(baseUrlApi + '/updateCustomTariff', details)
    },
    updateCustomTariffVerifiedStatus:(details)=> {
        return AxiosInstance.put(baseUrlApi + '/updateCustomTariffVerifiedStatus', details)
    },
    deleteCustomTariff:(customTariffID)=> {
        return AxiosInstance.delete(baseUrlApi + '/deleteCustomTariff?customTariffID=' + customTariffID)
    },
    insertCustomTariffFreightForwarder:(details)=> {
        return AxiosInstance.post(baseUrlApi + '/insertCustomTariffFreightForwarder', details)
    },
    updateCustomTariffFreightForwarder:(details)=> {
        return AxiosInstance.put(baseUrlApi + '/updateCustomTariffFreightForwarder', details)
    },
    deleteCustomTariffFreightForwarder:(customTariffID)=> {
        return AxiosInstance.delete(baseUrlApi + '/deleteCustomTariffFreightForwarder?customTariffID=' + customTariffID)
    },


    //UOM

    insertUOM:(details) =>{
        return AxiosInstance.post(baseUrlApi + '/insertUOM', details);
    },
    updateUOM:(details) =>{
        return AxiosInstance.put(baseUrlApi + '/updateUOM', details);
    },
    deleteUOM:(unitCode) =>{
        return AxiosInstance.delete(baseUrlApi + '/deleteUOM?unitCode=' + unitCode);
    },

    //itemtype

    insertItem:(details) =>{
        return AxiosInstance.post(baseUrlApi + '/insertItem', details);
    },
    updateItem:(details)=>{
        return AxiosInstance.put(baseUrlApi + '/updateItem', details);
    },
    deleteItem:(itemID)=>{
        return AxiosInstance.delete(baseUrlApi + '/deleteItem?itemID=' + itemID)
    },

}

export default BillingService;
